import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import ArModal from "../../../components/Modal/ArModal";
import BilSoModal from "../../../components/Modal/BilSoModal";
import FormAction from "../../../components/Actions/FormAction";
import PaymentModal from "../../../components/Modal/PaymentModal";
import ViewSoModal from "../../../components/Modal/ViewSoModal";

// Model
import { biMasterModel } from "../../../../model/SellProducts/BiMasterModel";
import { biDetailModel } from "../../../../model/SellProducts/BiDetailModel";

import {
  getData,
  getDataWithComp,
  formatCurrency,
  parseCurrency,
  getAlert,
  getMaxDocNo,
  deleteData,
  randomDelay,
  createSetRecNo,
  getMaxRecNoForTest,
} from "../../../../utils/SamuiUtils";

import {
  formatThaiDateUi,
  formatDateOnChange,
  formatStringDateToDate,
  formatThaiDateUiToDate,
  formatDateToStringDate,
  setCreateDateTime,
  getCreateDateTime,
  getCreateDateTime2,
} from "../../../../utils/DateUtils";

import { InvoiceHandleSubmit } from "../../../../utils/InvoiceUtils";
import {
  manageWhArPaymentData,
  setRemarkByPaymentType,
} from "../../../../utils/PaymentUtils";
import Swal from "sweetalert2";

const FormWater = ({ callInitialize, mode, name, docNo, getReport }) => {
  const [formMasterList, setFormMasterList] = useState(biMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [soDataList, setSoDataList] = useState([]);
  const [bilDatalist, setBilDatalist] = useState([]);
  const [arDataList, setArDataList] = useState([]);

  // การแสดงสถานะเอกสาร
  const [statusName, setStatusName] = useState("");
  const [statusColour, setStatusColour] = useState("");
  const [statusPaidName, setStatusPaidName] = useState("");
  const [statusPaidColour, setStatusPaidColour] = useState("");
  const [statusPaidTypeName, setStatusPaidTypeName] = useState("");
  const [statusPaidTypeColour, setStatusPaidTypeColour] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [displayDocNo, setDisplayDocNo] = useState(docNo);
  const [showConfirmModal, setShowConfirmModal] = React.useState(false);

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(false);
  const [vatAmount, setVatAmount] = useState(0);

  // สำหรับเก็บประเภทการชำระเงิน
  const [paymentType, setPaymentType] = useState({});
  const [paymentAmount, setPaymentAmount] = useState({});

  // เก็บตัวแปรสำหรับเช็ค
  const [chequeNo, setChequeNo] = useState("");
  const [chequeName, setChequeName] = useState("");
  const [chequeBranch, setChequeBranch] = useState("");

  const [base64Image, setBase64Image] = useState("");

  // ใช้สำหรับคำนวณยอดรวมใหม่ที่ตาราง
  const [soTotal, setSoTotal] = useState(0);
  const [soTotalVat, setSoTotalVat] = useState(0);
  const [soNetTotal, setSoNetTotal] = useState(0);

  useEffect(() => {
    initialize();
  }, []);

  useEffect(() => {
    setDisplayDocNo(docNo);
  }, [docNo]);

  useEffect(() => {
    if (mode === "U" || !formMasterList.docDate) return undefined;

    let isActive = true;
    const refreshReceiptDisplayDocNo = async () => {
      try {
        const recNoList = await getData(
          "Tb_Set_Rec_No",
          "1 = 1 ORDER BY RecNo DESC"
        );
        const nextRecNo = getMaxRecNoForTest(recNoList, formMasterList.docDate);
        if (isActive) setDisplayDocNo(nextRecNo);
      } catch (error) {
        console.error("Unable to refresh receipt document number", error);
      }
    };

    refreshReceiptDisplayDocNo();
    return () => {
      isActive = false;
    };
  }, [mode, formMasterList.docDate]);

  const initialize = async () => {
    const arDataList = await getDataWithComp(
      "Tb_Set_AR",
      "ORDER BY AR_Code ASC"
    );
    if (arDataList && arDataList.length > 0) {
      setArDataList(arDataList);
    }

    // Default จำนวนการชำระไว้ก่อนเป็น 0.00
    setPaymentAmount({
      cash: "0.00",
      transfer: "0.00",
      cheque: "0.00",
    });

    // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
    if (mode === "U") {
      await getModelByNo(arDataList);
    }
  };

  const getModelByNo = async (arDataList) => {
    try {
      // INV6806007
      const fromDatabase = await getDataWithComp(
        "API_0701_SO_H",
        `AND Doc_INV_No = '${docNo}'`
      );

      if (!fromDatabase || fromDatabase.length === 0) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลผู้ขายด้วย AR_ID
      const fromViewAr = arDataList.find(
        (ap) => ap.AR_Id === fromDatabase[0].AR_ID
      );

      if (!fromViewAr) {
        throw new Error("ไม่พบข้อมูลลูกค้า");
      }

      setStatusPaidName(fromDatabase[0].DocBLStatusPaid_Name);
      setStatusPaidColour(fromDatabase[0].DocBLStatusPaid_Colour);
      setStatusPaidTypeName(fromDatabase[0].DocStatusPaid_Type_Name);
      setStatusPaidTypeColour(fromDatabase[0].DocBLStatusPaid_Colour);

      // รอพี่คินทำ View ให้ ตอนนี้ Mock ไปก่อน
      if (fromDatabase[0].Doc_Status === 1) {
        setStatusName("ใบใหม่");
        setStatusColour("#EAA300");
      } else if (fromDatabase[0].Doc_Status === 5) {
        setStatusName("ปิดงาน");
        setStatusColour("#13A10E");
      } else if (fromDatabase[0].Doc_Status === 13) {
        setStatusName("ยกเลิก");
        setStatusColour("#000000");
        setStatusPaidName("");
        setStatusPaidColour("");
        setStatusPaidTypeName("");
        setStatusPaidTypeColour("");
      }

      // ค้นหาข้อมูลของ Detail ด้วย Doc_Id
      const fromDetail = await getDataWithComp(
        "API_0702_SO_D",
        `AND Doc_Id = ${fromDatabase[0].Doc_ID}`
      );

      if (!fromDetail || fromDetail.length === 0) {
        throw new Error("ไม่พบข้อมูลรายละเอียดเอกสาร");
      }

      // ใช้ Promise.all เพื่อโหลดข้อมูล SO พร้อมกัน
      const soDataResults = await Promise.all(
        fromDetail.map((detail) =>
          getData("API_0701_SO_H", `Doc_ID = ${detail.Doc_ID}`)
        )
      );

      const processedSoData = [];
      let soTotal = 0;
      let soTotalVat = 0;
      let soNetTotal = 0;

      // ใช้ flatMap() เพื่อให้แน่ใจว่า soDataResults ไม่ใช่อาร์เรย์ซ้อน
      await Promise.all(
        soDataResults
          .flatMap((dataArray) => dataArray)
          .map(async (fromViewSo) => {
            if (fromViewSo) {
              processedSoData.push({
                soId: fromViewSo.Doc_ID,
                soNo: fromViewSo.Doc_No,
                soDocDate: fromViewSo.Doc_Date,
                arName: fromViewSo.AR_Name,
                itemTotal: parseCurrency(fromViewSo.Total_Before_Vat) || parseCurrency(fromViewSo.BL_Total) || 0,
                totalVat: parseCurrency(fromViewSo.VAT) || parseCurrency(fromViewSo.BL_Vat) || 0,
                netTotal: parseCurrency(fromViewSo.NetTotal) || parseCurrency(fromViewSo.BL_Net_Total) || 0,
              });

              // ✅ คำนวณค่ารวม
              soTotal += parseCurrency(fromViewSo.Total_Before_Vat) || parseCurrency(fromViewSo.BL_Total) || 0;
              soTotalVat += parseCurrency(fromViewSo.VAT) || parseCurrency(fromViewSo.BL_Vat) || 0;
              soNetTotal += parseCurrency(fromViewSo.NetTotal) || parseCurrency(fromViewSo.BL_Net_Total) || 0;

            }
          })
      );

      setSoTotal(soTotal);
      setSoTotalVat(soTotalVat);
      setSoNetTotal(soNetTotal);
      setFormDetailList(processedSoData);

      // เรียก onRowSelectSo แค่ครั้งเดียวหลังจาก loop เสร็จ
      await Promise.all(processedSoData.map(onRowSelectSo));

      const data = fromDatabase[0];
      setIsVatChecked(data.BL_Is_Vat === 1);
      setFormMasterList({
        docId: data.Doc_Id,
        compId: data.Comp_Id,
        docNo: data.Doc_No,
        docDate: formatThaiDateUi(data.Doc_Date || null),
        docDueDate: formatThaiDateUi(data.Doc_Due_Date || null),
        docStatus: data.Doc_Status,
        docPaidStatus: data.Doc_Paid_Status,
        arID: data.AR_ID,
        arCode: data.AR_Code,
        arName: data.AR_Name,
        createdDate: setCreateDateTime(data.Created_Date),
        createdByName: data.Created_By_Name,
        createdById: data.Created_By_Id,
        updateDate: getCreateDateTime(),
        updateByName: window.localStorage.getItem("name"),
        updateById: window.localStorage.getItem("emp_id"),
        cancelDate: setCreateDateTime(data.Cancel_Date),
        cancelByName: data.Cancel_By_Name,
        cancelById: data.Cancel_By_Id,
        blTotal: data.BL_Total,
        blDis: data.BL_Dis,
        blIsVat: data.BL_Is_Vat,
        blVat: data.BL_Vat,
        blNetTotal: data.BL_Net_Total,
        docIsInv: data.Doc_Is_INV,
        docInvNo: data.Doc_INV_No,
        docIsInvFrom: data.Doc_Is_INV_From,
        discountValue: data.Discount_Value,
        discountValueType: data.Discount_Value_Type,
        docPaidPic: data.Doc_Paid_Pic,
        docStatusPaidType: data.Doc_Status_Paid_Type,
        docRemark1: data.Doc_Remark1,
        docRemark2: data.Doc_Remark2,
        doc_bl_receive_date: formatThaiDateUi(data.Doc_BL_Receive_Date || null),
        payTotal: data.Pay_Total,
        arAdd1: fromViewAr.AR_Add1,
        arAdd2: fromViewAr.AR_Add2,
        arAdd3: fromViewAr.AR_Add3,
        arProvince: fromViewAr.AR_Province,
        arZipcode: fromViewAr.AR_Zipcode,
        arTaxNo: fromViewAr.AR_TaxNo,
      });

      // กำหนดประเภทการจ่ายต่อ กรณีที่ค้างจ่าย
      if (data.Doc_Paid_Status === 1) {
        switch (data.Doc_Status_Paid_Type) {
          // ถ้าเป็น 1 คือ เงินสด
          case 1:
            setPaymentType({
              cash: true,
              transfer: false,
              cheque: false,
            });
            setPaymentAmount({
              cash: formatCurrency(data.Pay_Total),
              transfer: "0.00",
              cheque: "0.00",
            });
            break;

          // ถ้าเป็น 2 คือ เงินโอน
          case 2:
            setPaymentType({
              cash: false,
              transfer: true,
              cheque: false,
            });
            setPaymentAmount({
              cash: "0.00",
              transfer: formatCurrency(data.Pay_Total),
              cheque: "0.00",
            });
            break;

          // ถ้าเป็น 3 คือ เช็ค
          case 3:
            setPaymentType({
              cash: false,
              transfer: false,
              cheque: true,
            });
            setPaymentAmount({
              cash: "0.00",
              transfer: "0.00",
              cheque: formatCurrency(data.Pay_Total),
            });

            const payHistoryForCheque = await getData(
              "Pay_History",
              `DocCode_Id = 14 AND Pay_Type = 3 AND Doc_Id = ${fromDatabase.Doc_Id}`
            );
            if (payHistoryForCheque && payHistoryForCheque.length > 0) {
              const payData = payHistoryForCheque[0];
              setChequeNo(payData.Pay_Cheque_No);
              setChequeName(payData.Pay_Cheque_Branch);
              setChequeBranch(
                moment(payData.Pay_Cheque_date)
                  .add(543, "years")
                  .format("DD/MM/YYYY")
              );
            }

            break;

          // ถ้าเป็น 6 แปลว่าจ่ายหลายช่องทาง ต้องไปค้นหาที่ Table : Pay_History เพิ่ม
          case 6:
            const paymentHistoryResponse = await getData(
              "Pay_History",
              `DocCode_Id = 14 AND Doc_Id = ${fromDatabase[0].Doc_Id}`
            );
            if (paymentHistoryResponse && paymentHistoryResponse.length > 0) {
              // Loop ผ่านข้อมูลการจ่ายหลายช่องทาง
              for (const payment of paymentHistoryResponse) {
                switch (payment.Pay_Type) {
                  // ถ้า payment.Pay_Type === 1 คือ เงินสด
                  case 1:
                    setPaymentType((prev) => ({
                      ...prev,
                      cash: true,
                    }));
                    setPaymentAmount((prev) => ({
                      ...prev,
                      cash: formatCurrency(payment.Pay_Amount),
                    }));
                    break;

                  // ถ้า payment.Pay_Type === 2 คือ เงินโอน
                  case 2:
                    setPaymentType((prev) => ({
                      ...prev,
                      transfer: true,
                    }));
                    setPaymentAmount((prev) => ({
                      ...prev,
                      transfer: formatCurrency(payment.Pay_Amount),
                    }));
                    break;

                  // ถ้า payment.Pay_Type === 3 คือ เช็ค
                  case 3:
                    setPaymentType((prev) => ({
                      ...prev,
                      cheque: true,
                    }));
                    setPaymentAmount((prev) => ({
                      ...prev,
                      cheque: formatCurrency(payment.Pay_Amount),
                    }));

                    // ถ้าเป็นเช็ค ต้องเซ็ทเลขที่เช็ค ชื่อ และ วันที่แบบนี้ด้วย
                    setChequeNo(payment.Pay_Cheque_No);
                    setChequeName(payment.Pay_Cheque_Branch);
                    setChequeBranch(
                      moment(payment.Pay_Cheque_date)
                        .add(543, "years")
                        .format("DD/MM/YYYY")
                    );
                    break;

                  // กรณีที่ไม่ตรงกับ 1, 2, หรือ 3
                  default:
                    console.warn(
                      `พบประเภทการจ่ายที่ไม่รู้จัก: ${payment.Pay_Type}`
                    );
                    break;
                }
              }
            }
            break;

          // กรณีอื่นๆ ถ้ามี
          default:
            console.log("ประเภทการจ่ายไม่ถูกต้อง");
            break;
        }
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  // const handleCheckboxChange = (event) => {
  //   const { name } = event.target;
  //   setSelectedDiscountValueType(
  //     selectedDiscountValueType === name ? null : name
  //   );
  // };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    // ตรวจสอบว่า value เป็น moment object หรือไม่
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : value;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: formatDateOnChange(newValue),
    }));
  };

  // SET AR
  const [showArModal, setShowArModal] = useState(false);
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);
  const onRowSelectAr = (arSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        arID: arSelected.AR_Id,
        arCode: arSelected.AR_Code,
        arName: arSelected.AR_Name,
        arAdd1: arSelected.AR_Add1,
        arAdd2: arSelected.AR_Add2,
        arAdd3: arSelected.AR_Add3,
        arProvince: arSelected.AR_Province,
        arZipcode: arSelected.AR_Zipcode,
        arTaxNo: arSelected.AR_TaxNo,
      });
      handleArClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET SO
  const [showSoModal, setShowSoModal] = useState(false);
  const handleSoShow = async () => {
    let soDataList;
    let bilDataList;

    // สร้างเงื่อนไขที่ต้องการสำหรับการดึงข้อมูล
    const condition = `
      AND Doc_INV_No IS NULL
      AND Doc_Status <> '13'
      
    `;
    // AND Doc_Status_Paid = '1' OR Doc_Status_Paid = '2'


    if (mode === "U") {
      soDataList = await getDataWithComp(
        "API_0701_SO_H",
        `${condition} AND (Doc_BL_No IS NULL OR Doc_BL_No = '${docNo}') ORDER BY Doc_No DESC`
      );
      bilDataList = await getDataWithComp(
        "API_1301_BL_H",
        `AND Doc_No = '${docNo}' AND AR_Code = '${formMasterList.arCode}' AND Doc_Status <> '13' AND Doc_Paid_Status = '0' ORDER BY Doc_No DESC`
      );
    } else {
      soDataList = await getDataWithComp(
        "API_0701_SO_H",
        `${condition} AND Doc_BL_No IS NULL ORDER BY Doc_No DESC`
      );
      bilDataList = await getDataWithComp(
        "API_1301_BL_H",
        `AND AR_Code = '${formMasterList.arCode}' AND Doc_Status <> '13' AND Doc_Paid_Status = '0'ORDER BY Doc_No DESC`
      );
    }

    if (soDataList && soDataList.length > 0) {
      setSoDataList(soDataList);
    }
    if (bilDataList && bilDataList.length > 0) {
      setBilDatalist(bilDataList);
    }


    setShowSoModal(true);
  };



  const handleSoClose = () => setShowSoModal(false);
  const onRowSelectSo = async (soSelected) => {
    try {
      if (!Array.isArray(soSelected)) return;

      // ล้างข้อมูลเก่าก่อน
      if (mode === "I") {
        setFormDetailList([]);
      }
      // เคลียร์ค่า VAT ด้วย
      setIsVatChecked(false);
      const createNewRow = (index, itemSelected) => {
        let netTotal = parseCurrency(itemSelected.NetTotal) || parseCurrency(itemSelected.BL_Net_Total) || 0;
        let itemTotal = parseCurrency(itemSelected.Total_Before_Vat) || parseCurrency(itemSelected.BL_Total) || 0;
        let totalVat = parseCurrency(itemSelected.VAT) || parseCurrency(itemSelected.BL_Vat) || 0;
        if (totalVat > 0) {
          setIsVatChecked(true);
        } else {
          setIsVatChecked(false);
        }
        return {
          ...biDetailModel(index + 1),
          soId: itemSelected.Doc_ID || itemSelected.Doc_Id,
          soNo: itemSelected.Doc_No,
          soDocDate: itemSelected.Doc_Date,
          arName: itemSelected.AR_Name,
          remark: itemSelected.Doc_Remark1,
          itemTotal: formatCurrency(itemTotal),
          netTotal: formatCurrency(netTotal),
          totalVat: formatCurrency(totalVat),
        };
      };
      const newFormDetails = soSelected.map((item, index) =>
        createNewRow(formDetailList.length + index, item)
      );

      // คำนวณเงินยอดรวม
      let soTotal = 0;
      let soTotalVat = 0;
      let soNetTotal = 0;
      for (const soData of soSelected) {
        soTotal += parseCurrency(soData.Total_Before_Vat) || parseCurrency(soData.BL_Total) || 0;
        soTotalVat += parseCurrency(soData.VAT) || parseCurrency(soData.BL_Vat) || 0;
        soNetTotal += parseCurrency(soData.NetTotal) || parseCurrency(soData.BL_Net_Total) || 0;
      }

      setSoTotal(soTotal);
      setSoTotalVat(soTotalVat);
      setSoNetTotal(soNetTotal);
      // if (soNetTotal > 0) {
      //   setIsVatChecked(true);
      // } else {
      //   setIsVatChecked(false);
      // }

      if (mode === "I") {
        setFormDetailList(newFormDetails);
      } else {
        setFormDetailList((prev) => [...prev, ...newFormDetails]);
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const onConfirmSoSelection = async (soSelected) => {
    if (!soSelected || soSelected.length === 0) {
      getAlert("FAILED", "กรุณาเลือกใบขายสินค้าก่อน");
      return;
    }
    if (formDetailList.length > 0) {
      Swal.fire({
        title: "ยืนยันการเลือกใบขายสินค้า",
        text: "คุณต้องการลบข้อมูลใบขายสินค้าที่เลือกไว้ก่อนหน้านี้หรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ใช่, ลบข้อมูล",
        cancelButtonText: "ไม่, ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          // ถ้าเลือกใช่ ให้ลบข้อมูลเก่า
          const hasVat = soSelected.some((so) => so.IsVat === 1);
          const hasNoVat = soSelected.some((so) => so.IsVat === 2);

          if (hasVat && hasNoVat) {
            getAlert(
              "FAILED",
              "ไม่สามารถเลือกใบขายสินค้าที่มี VAT และไม่มี VAT ร่วมกันได้"
            );
            return;
          }
          setFormDetailList([]);
          handleSoClose();
          onRowSelectSo(soSelected);
          getAlert("OK", "การเลือกใบขายสินค้าสำเร็จ");
        } else {
          handleSoClose();
        }
      }
      );
    } else {
      const hasVat = soSelected.some((so) => so.IsVat === 1);
      const hasNoVat = soSelected.some((so) => so.IsVat === 2);

      if (hasVat && hasNoVat) {
        getAlert(
          "FAILED",
          "ไม่สามารถเลือกใบขายสินค้าที่มี VAT และไม่มี VAT ร่วมกันได้"
        );
        return;
      }
      handleSoClose();
      onRowSelectSo(soSelected);
      getAlert("OK", "การเลือกใบขายสินค้าสำเร็จ");
    }

  };

  const handleSubmit = async () => {
    console.log("handleSubmit called");
    // try {
    //   // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
    //   await randomDelay();

    //   const masterList = await getDataWithComp(
    //     "API_1301_BL_H",
    //     `ORDER BY Doc_No DESC`
    //   );
    //   let newMaxBi = docNo;

    //   if (masterList && masterList.length > 0) {
    //     const maxBi = getMaxDocNo(masterList, "REC");
    //     newMaxBi = maxBi;
    //   }

    //   // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
    //   if (!formMasterList.arID && !formMasterList.arCode) {
    //     getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
    //     return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
    //   }

    //   // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
    //   if (!formDetailList || formDetailList.length === 0) {
    //     getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบรายละเอียดใบขาย");
    //     return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
    //   }

    //   // ข้อมูลหลักที่จะส่งไปยัง API
    //   const formMasterData = {
    //     comp_id: window.localStorage.getItem("company"),
    //     doc_no: newMaxBi,
    //     doc_date: formatStringDateToDate(formMasterList.docDate),
    //     doc_due_date: formatStringDateToDate(formMasterList.docDueDate),
    //     doc_status: 1,
    //     doc_paid_status: 0,
    //     ar_id: formMasterList.arID,
    //     created_date: formatThaiDateUiToDate(formMasterList.createdDate),
    //     created_by_name: window.localStorage.getItem("name"),
    //     created_by_id: window.localStorage.getItem("emp_id"),
    //     update_date: null,
    //     update_by_name: null,
    //     update_by_id: null,
    //     cancel_date: null,
    //     cancel_by_name: null,
    //     cancel_by_id: null,
    //     bl_total: totalPrice,
    //     bl_dis: receiptDiscount,
    //     bl_is_vat: isVatChecked ? parseCurrency("1") : parseCurrency("2"),
    //     bl_vat: vatAmount,
    //     bl_net_total: grandTotal,
    //     doc_is_inv: parseCurrency("0"),
    //     doc_inv_no: null,
    //     doc_is_inv_from: null,
    //     discount_value: parseCurrency(formMasterList.discountValue || 0),
    //     discount_type: parseCurrency(selectedDiscountValueType),
    //     doc_paid_pic: null,
    //     doc_status_paid_type: null,
    //     doc_remark1: formMasterList.docRemark1,
    //     doc_remark2: formMasterList.docRemark2,
    //     doc_bl_receive_date: null,
    //     pay_total: parseCurrency("0"),
    //   };

    //   // ส่งข้อมูลหลักไปยัง API
    //   const response = await Axios.post(
    //     `${process.env.REACT_APP_API_URL}/api/create-bi-h`,
    //     formMasterData,
    //     {
    //       headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
    //     }
    //   );

    //   if (!base64Image) {
    //     const formData = {
    //       comp_id: window.localStorage.getItem("company"),
    //       doc_no: newMaxBi,
    //       doc_paid_pic: base64Image,
    //     };
    //     await Axios.post(
    //       `${process.env.REACT_APP_API_URL}/api/update-so-h-slip`,
    //       formData,
    //       { headers: { key: process.env.REACT_APP_ANALYTICS_KEY } }
    //     );
    //   }

    //   if (response.data.status === "OK") {
    //     const getDocIdResponse = await Axios.post(
    //       `${process.env.REACT_APP_API_URL}/api/get-by-doc-no`,
    //       {
    //         table: "BL_H",
    //         doc_no: formMasterData.doc_no,
    //         comp_id: window.localStorage.getItem("company"),
    //       },
    //       {
    //         headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
    //       }
    //     );

    //     if (getDocIdResponse && getDocIdResponse.data.length > 0) {
    //       const docId = parseCurrency(getDocIdResponse.data[0].Doc_Id, 10);

    //       const detailPromises = formDetailList.map(async (item) => {
    //         const formDetailData = {
    //           doc_id: docId,
    //           so_id: item.soId,
    //         };

    //         return Axios.post(
    //           `${process.env.REACT_APP_API_URL}/api/create-bi-d`,
    //           formDetailData,
    //           {
    //             headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
    //           }
    //         );
    //       });

    //       await Promise.all(detailPromises);
    //     }

    //     callInitialize();
    //     getAlert(response.data.status, response.data.message);
    //   }
    // } catch (error) {
    //   getAlert("FAILED", error.response?.data?.message || error.message);
    // }
  };

  const handleUpdate = async () => {
    try {
      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบรายละเอียดใบขาย");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: formMasterList.compId,
        doc_no: formMasterList.docNo,
        doc_date: formatStringDateToDate(formMasterList.docDate),
        doc_due_date: formatStringDateToDate(formMasterList.docDueDate),
        doc_status: parseCurrency(formMasterList.docStatus, 10),
        doc_paid_status: parseCurrency(formMasterList.docPaidStatus, 10),
        ar_id: formMasterList.arID,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        cancel_date: formatThaiDateUiToDate(formMasterList.cancelDate),
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        bl_total: totalPrice,
        bl_dis: receiptDiscount,
        bl_is_vat: isVatChecked
          ? parseCurrency("1", 10)
          : parseCurrency("2", 10),
        bl_vat: vatAmount,
        bl_net_total: grandTotal,
        doc_is_inv: parseCurrency("0", 10),
        doc_inv_no: formMasterList.docInvNo,
        doc_is_inv_from: formMasterList.docIsInvFrom,
        discount_value: parseCurrency(formMasterList.discountValue || 0),
        discount_type: parseCurrency(selectedDiscountValueType, 10),
        doc_paid_pic: formMasterList.docPaidPic,
        doc_status_paid_type: formMasterList.docStatusPaidType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        doc_bl_receive_date: formatThaiDateUiToDate(
          formMasterList.docBlReceiveDate
        ),
        pay_total: parseCurrency(formMasterList.payTotal),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-bi-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
        await deleteData(
          "BL_D",
          `WHERE Doc_ID = ${parseCurrency(formMasterList.docId, 10)}`
        );

        const detailPromises = formDetailList.map(async (item) => {
          const formDetailData = {
            doc_id: parseCurrency(formMasterList.docId, 10),
            so_id: item.soId,
          };

          return Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-bi-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        });

        await Promise.all(detailPromises);

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseCurrency("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-bi-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleTax = async () => {
    try {
      const response = await InvoiceHandleSubmit(
        "BI", // BI = ใบวางบิล, SO = ใบขาย
        formMasterList.arID, // arId
        formMasterList.arCode, // arCode
        formMasterList.arName, // arName
        formMasterList.arTaxNo, // arTaxNo
        formMasterList.arAdd1, // arAdd1
        formMasterList.arAdd2, // arAdd2
        formMasterList.arAdd3, // arAdd3
        formMasterList.arProvince, // arProvince
        formMasterList.arZipcode, // arZipcode
        null, // arContact1
        null, // arContact2
        null, // arTel1
        null, // arTel2
        formMasterList.docDate, // docDate
        1, // docFor
        formMasterList.docId, // refDocId
        formMasterList.docNo, // refDoc
        formMasterList.docDate, // refDocDate
        formMasterList.docRemark1, // docRemark1
        isVatChecked // isVat
      );

      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const [showPayTypeModal, setShowPayTypeModal] = useState(false);
  const handlePayTypeShow = () => setShowPayTypeModal(true);
  const handlePayTypeClose = async () => {
    setShowPayTypeModal(false);
    setPaymentType({});
    setPaymentAmount({});

    if (mode === "U") {
      await initialize();
    }
  };
  const handleUploadSlip = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const checkPayment = async () => {
    const totalPaidAmount =
      (paymentType.cash ? parseCurrency(paymentAmount.cash) : 0) +
      (paymentType.transfer ? parseCurrency(paymentAmount.transfer) : 0) +
      (paymentType.cheque ? parseCurrency(paymentAmount.cheque) : 0);

    if (parseCurrency(totalPaidAmount) === 0) {
      getAlert("FAILED", "กรุณาระบุยอดการชำระเงิน");
      setIsLoading(false);
      return;
    }

    // if (parseCurrency(totalPaidAmount) > parseCurrency(grandTotal)) {
    //   getAlert("FAILED", "กรุณาระบุยอดการชำระเงินไม่เกินกว่าที่ต้องชำระเงิน");
    //   setIsLoading(false);
    //   return;
    // }

    await setShowConfirmModal(true);
  };
  const handleSubmitPayment = async () => {
    try {
      setIsLoading(true);

      // ตรวจสอบค่าว่าเลือกประเภทการชำระเงินหรือยัง
      if (!paymentType) {
        getAlert("FAILED", "กรุณาเลือกประเภทการชำระเงิน");
        setIsLoading(false);
        return; // หยุดการทำงานของฟังก์ชันหากไม่ได้เลือกประเภทการชำระเงิน
      }

      let docPaidStatus;
      const totalPaidAmount =
        (paymentType.cash ? parseCurrency(paymentAmount.cash) : 0) +
        (paymentType.transfer ? parseCurrency(paymentAmount.transfer) : 0) +
        (paymentType.cheque ? parseCurrency(paymentAmount.cheque) : 0);

      if (parseCurrency(totalPaidAmount) === 0) {
        getAlert("FAILED", "กรุณาระบุยอดการชำระเงิน");
        setIsLoading(false);
        return;
      }

      if (parseCurrency(totalPaidAmount) < parseCurrency(grandTotal)) {
        docPaidStatus = 1; // ค้างจ่าย
      } else {
        docPaidStatus = 2; // จ่ายครบ
      }

      // ตรวจสอบช่องทางที่ถูกเลือก
      let docStatusPaidType = 6;
      const selectedMethods = Object.keys(paymentType).filter(
        (method) =>
          paymentType[method] && parseCurrency(paymentAmount[method]) > 0
      );

      if (selectedMethods.length === 1) {
        const method = selectedMethods[0];
        const paymentTypeMap = {
          cash: 1,
          transfer: 2,
          cheque: 3,
        };
        docStatusPaidType = paymentTypeMap[method] || 6;
      }

      // เก็บจำนวนยอดการชำระเงินเดิมที่เคยจ่ายไว้ก่อน เอาไว้ตัดสต็อกนะ
      const oldPayTotal = parseCurrency(formMasterList.payTotal);

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formPaidData = {
        doc_status:
          docPaidStatus === 2 ? parseCurrency("5") : parseCurrency("1", 10),
        doc_paid_status: parseCurrency(docPaidStatus),
        doc_status_paid_type: parseCurrency(docStatusPaidType),
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        doc_no: formMasterList.docNo,
        comp_id: window.localStorage.getItem("company"),
        doc_paid_pic: base64Image,
        pay_total: parseCurrency(totalPaidAmount),
      };
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-bi-paid`,
        formPaidData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );


      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        // สร้าง RecNo เพียงครั้งเดียวก่อน loop
        await randomDelay();
        const findMaxRecNo = await getData(
          "Tb_Set_Rec_No",
          `1 = 1 ORDER BY RecNo DESC`
        );
        let maxRec = getMaxRecNoForTest(findMaxRecNo, formMasterList.docDate);
        await createSetRecNo(maxRec);

        // เพิ่ม Business มาใหม่ By SpriteZadis
        for (const formDetail of formDetailList) {
          // เอาใบขายที่เก็บอยู่ใน BL_D มาหยอดสถานะว่า 'จ่ายแล้ว'
          await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/update-so-paid-complete`,
            {
              doc_status_paid:
                docPaidStatus === 2 ? parseCurrency("3") : parseCurrency("2"),
              update_date: formatThaiDateUiToDate(getCreateDateTime()),
              update_by_name: window.localStorage.getItem("name"),
              update_by_id: window.localStorage.getItem("emp_id"),
              doc_no: formDetail.soNo,
              doc_inv_no: maxRec,
              comp_id: window.localStorage.getItem("company"),
              doc_so_receive_date: formatThaiDateUiToDate(
                getCreateDateTime()
              ),
              doc_status_paid_type: parseCurrency(docStatusPaidType),
            },
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        }

        const paymentTypeMap = {
          cash: 1,
          transfer: 2,
          cheque: 3,
        };

        // formMasterList.docPaidStatus === 1 คือการแก้ไขชำระเงิน
        if (formMasterList.docPaidStatus === 1) {
          await handleUpdatePayment(oldPayTotal);
        } else {
          // ใช้ RecNo ที่สร้างไว้แล้วข้างบน ไม่ต้องสร้างใหม่
          const formUpdateData = {
            table: "BL_H",
            doc_is_inv: parseCurrency("0", 10),
            doc_inv_no: maxRec,
            doc_is_inv_from: parseCurrency("0", 10),
            doc_bl_receive_date: formatThaiDateUiToDate(getCreateDateTime()),
            where: `WHERE Doc_Id = ${formMasterList.docId}`,
          };

          await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/update-invoice`,
            formUpdateData,
            {
              headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
            }
          );
        }
        for (const method of Object.keys(paymentType)) {
          if (paymentType[method] && parseCurrency(paymentAmount[method]) > 0) {
            const formPaymentHistoryData = {
              doc_code_id: 14,
              doc_id: parseCurrency(formMasterList.docId),
              pay_type: paymentTypeMap[method],
              pay_amount:
                docStatusPaidType === 6
                  ? parseCurrency(paymentAmount[method])
                  : parseCurrency(totalPaidAmount),
              pay_remark: null,
              pay_datetime: new Date(),
              pay_by: localStorage.getItem("name"),
              pay_to_acc_no: null,
              pay_to_branch: null,
              pay_to_acc_name: null,
              pay_cheque_no: paymentTypeMap[method] === 3 ? chequeNo : null,
              pay_cheque_name: paymentTypeMap[method] === 3 ? chequeName : null,
              pay_cheque_branch:
                paymentTypeMap[method] === 3 ? chequeBranch : null,
              pay_cheque_type: null,
            };

            // ส่งข้อมูลไปยัง API
            await Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-pay-history`,
              formPaymentHistoryData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          }
        }

        // ค้นหาข้อมูลล่าสุด และทำการอัพเดตค่าใน PAYMENT_ONHAND & PAYMENT_STC
        const getNewData = await getDataWithComp(
          "API_1301_BL_H",
          `AND Doc_Id = ${formMasterList.docId}`
        );
        if (getNewData && getNewData.length > 0) {
          const data = getNewData[0];
          if (data.Doc_Status_Paid_Type === 6) {
            const getPayHistory = await getData(
              "Pay_History",
              `DocCode_Id = 14 AND Doc_Id = ${formMasterList.docId}`
            );
            if (getPayHistory && getPayHistory.length > 0) {
              for (const pay of getPayHistory) {
                await manageWhArPaymentData(
                  data.AR_ID, // AR_ID ของลูกค้านั้นๆ
                  data.AR_Code, // AR_Code ของสิ่งนั้นๆ
                  data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                  0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
                  "AI", // ประเภท เช่น AI/AO
                  parseCurrency(pay.Pay_Amount), // ค่าจำนวนเงิน
                  data.Doc_Id, // ไอดีเอกสาร
                  data.Doc_No, // เลขเอกสาร
                  data.Doc_No, // เลขเอกสารอ้างอิง
                  await setRemarkByPaymentType(parseCurrency(pay.Pay_Type)) // หมายเหตุ
                );
              }
            }
          } else {
            // ปรับยอดเงินออก
            await manageWhArPaymentData(
              data.AR_ID, // AR_ID ของลูกค้านั้นๆ
              data.AR_Code, // AR_Code ของสิ่งนั้นๆ
              data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
              0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
              "AI", // ประเภท เช่น AI/AO
              parseCurrency(data.Pay_Total), // ค่าจำนวนเงิน
              data.Doc_Id, // ไอดีเอกสาร
              data.Doc_No, // เลขเอกสาร
              data.Doc_No, // เลขเอกสารอ้างอิง
              await setRemarkByPaymentType(
                parseCurrency(data.Doc_Status_Paid_Type)
              ) // หมายเหตุ
            );
          }
        }

        setIsLoading(false);
        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };
  const handleUpdatePayment = async (oldPayTotal) => {
    try {
      // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
      await deleteData(
        "Pay_History",
        `WHERE DocCode_Id = 14 AND Doc_Id = ${formMasterList.docId}`
      );

      // เอายอดเดิมก่อนที่จะแก้ไข มาทำการจ่ายคืนสต็อกก่อน
      const getOldData = await getDataWithComp(
        "API_1301_BL_H",
        `AND Doc_Id = ${formMasterList.docId}`
      );
      if (getOldData && getOldData.length > 0) {
        const data = getOldData[0];

        // ปรับยอดเงินออก
        await manageWhArPaymentData(
          data.AR_ID, // AR_ID ของลูกค้านั้นๆ
          data.AR_Code, // AR_Code ของสิ่งนั้นๆ
          data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
          0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
          "AO", // ประเภท เช่น AI/AO
          parseCurrency(oldPayTotal), // ค่าจำนวนเงิน
          data.Doc_Id, // ไอดีเอกสาร
          data.Doc_No, // เลขเอกสาร
          data.Doc_No, // เลขเอกสารอ้างอิง
          `แก้ไขการชำระเงินใบวางบิล : ${data.Doc_No}` // หมายเหตุ
        );
      }
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  // ใช้สำหรับปรับสถานะที่เป็น 'ค้างจ่าย' ให้เป็น 'จ่ายครบ' (เฉพาะเช็ค)
  const handleUpdatePaidStatus = async () => {
    try {
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formUpdateData = {
        doc_paid_status: parseCurrency("2", 10),
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        doc_no: formMasterList.docNo,
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-bi-paid-complete`,
        formUpdateData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  // เปิด Modal สำหรับดูรายละเอียดใบขาย
  const [showViewSoModal, setShowViewSoModal] = useState(false);
  const [selectedSoData, setSelectedSoData] = useState(null);
  const handleViewSoClose = () => {
    setShowViewSoModal(false);
    setSelectedSoData(null);

    // ลบ class 'modal-open' จาก body
    document.body.classList.remove("modal-open");

    // ลบ element ที่อาจถูกซ้อน เช่น backdrop ของ Modal
    const backdrops = document.getElementsByClassName("modal-backdrop");
    while (backdrops.length > 0) {
      backdrops[0].parentNode.removeChild(backdrops[0]);
    }
  };
  const handleViewSo = (soData) => {
    setSelectedSoData(soData);
    setShowViewSoModal(true);
  };

  // การคำนวณยอดรวม (totalPrice)
  useEffect(() => {
    const total = formDetailList.reduce(
      (acc, item) => acc + (parseCurrency(item.itemTotal) || 0),
      0
    );
    setTotalPrice(total);
  }, [formDetailList]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    const vat = isVatChecked ? totalPrice * 0.07 : 0;
    setVatAmount(parseCurrency(vat.toFixed(2)));
  }, [totalPrice, isVatChecked]);

  // การคำนวณส่วนลด (receiptDiscount)
  // useEffect(() => {
  //   let discountValue = parseCurrency(formMasterList.discountValue || 0);
  //   let discountType = String(formMasterList.discountType || '2');
  //   let receiptDiscount = 0;

  //   if (discountType === '2') { // เปอร์เซ็นต์
  //     receiptDiscount = ((totalPrice + vatAmount) / 100) * discountValue;
  //   } else if (discountType === '1') { // จำนวนเงิน
  //     receiptDiscount = discountValue;
  //   }

  //   setReceiptDiscount(receiptDiscount);
  // }, [totalPrice, vatAmount, formMasterList.discountValue, selectedDiscountValueType]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal)
  // useEffect(() => {
  //   const subFinal = totalPrice;
  //   setSubFinal(subFinal);
  // }, [totalPrice]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const grandTotal = totalPrice + vatAmount;
    setGrandTotal(parseCurrency(grandTotal));
  }, [totalPrice, vatAmount]);

  return (
    <>
      <Breadcrumbs
        page={mode === "U" ? docNo : displayDocNo}
        isShowStatus={mode === "U"}
        statusName={statusName}
        statusColour={statusColour}
        otherStatusName={statusPaidName}
        otherStatusColour={statusPaidColour}
        otherTypeName={statusPaidTypeName}
        otherTypeColour={statusPaidTypeColour}
        items={[
          { name: "งานบัญชี", url: "/account" },
          { name: name, url: "/receipt" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
        docIsINV={formMasterList.docIsInv}
        onHandleClick={() => {
          const reportType = formMasterList.docNo.startsWith("BI") ? "INV_RECEIPT" : "so_receipt";
          getReport(reportType, formMasterList.docNo);

        }}
        onHandleInvoice1={() => getReport("inv1", formMasterList.docInvNo)}
        onHandleInvoice2={() => getReport("inv2", formMasterList.docInvNo)}
        onHandleInvoice3={() => getReport("inv_water_receipt", docNo)}
        urlImg={formMasterList.docPaidPic}
        base64Image={base64Image}
        setBase64Image={setBase64Image}
      />

      {/* Loading Spinner */}
      {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <div
        className="hidden-scrollbar"
        style={{ maxHeight: "auto", overflowY: "auto" }}
      >
        <div className="body">
          <div class="container-fluid">
            <div className="row mb-1">
              <div className="col-4">
                <div className="d-flex">
                  <label>วันที่เอกสาร : </label>
                  <Datetime
                    className="input-spacing-input-date"
                    name="whDocDate"
                    value={formMasterList.docDate || null}
                    onChange={(date) => handleChangeDateMaster(date, "docDate")}
                    dateFormat="DD-MM-YYYY"
                    timeFormat={false}
                    inputProps={{ readOnly: true, disabled: mode === "U" }}
                  />
                </div>
              </div>
              <div className="col-4 text-left">
                <div className="d-flex align-items-center">
                  <label>ลูกค้า</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control input-spacing"
                      name="apCode"
                      value={
                        (formMasterList.arCode || "") +
                        " " +
                        (formMasterList.arName || "")
                      }
                      onChange={handleChangeMaster}
                      disabled={true}
                    />
                    <button
                      className="btn btn-outline-secondary"
                      onClick={handleArShow}
                      disabled={mode === "U" ? true : false}
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>
                <ArModal
                  showArModal={showArModal}
                  handleArClose={handleArClose}
                  arDataList={arDataList}
                  onRowSelectAr={onRowSelectAr}
                />
              </div>
              <div className="col-4">
                <div className="d-flex">
                  <label>สร้างโดย : </label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={formMasterList.createdByName}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                <div className="d-flex">
                  <label>รายละเอียดเอกสาร : </label>
                  {/* <input
                    type="text"
                    className="form-control input-spacing"
                    name="docRemark1"
                    value={formMasterList.docRemark1 || ""}
                    onChange={handleChangeMaster}
                    disabled={formMasterList.docIsInv === 1 || formMasterList.docStatus !== 1}
                  /> */}
                  <textarea
                    type="text"
                    className=" input-spacing"
                    name="docRemark1"
                    value={formMasterList.docRemark1 || ""}
                    onChange={handleChangeMaster}
                    style={{ height: "65px" }}
                    disabled={
                      formMasterList.docIsInv === 1 ||
                      formMasterList.docStatus !== 1
                    }
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="d-flex align-items-center">
                  <label>ที่อยู่</label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="apAdd1"
                    value={formMasterList.arAdd1 || ""}
                    onChange={handleChangeMaster}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="d-flex">
                  <label className="">วันที่สร้าง : </label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={formMasterList.createdDate}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                <div className="d-flex">
                  <label>หมายเหตุธุรการ : </label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="docRemark2"
                    value={formMasterList.docRemark2 || ""}
                    onChange={handleChangeMaster}
                    disabled={
                      formMasterList.docIsInv === 1 ||
                      formMasterList.docStatus !== 1
                    }
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="d-flex align-items-center">
                  <label></label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={
                      (formMasterList.arAdd2 || "") +
                      " " +
                      (formMasterList.arAdd3 || "")
                    }
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                {/* <div className="d-flex">
              <label>วันที่เอกสารอ้างอิง : </label>
              <input
                //type="date"
                type="text"
                className="form-control input-spacing"
                name="refDocDate"
                value={formMasterList.refDocDate || ''}
                disabled={true}
              />
            </div> */}
              </div>
              <div className="col-4">
                <div className="d-flex align-items-center">
                  <label></label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={
                      (formMasterList.arProvince || "") +
                      " " +
                      (formMasterList.arZipcode || "")
                    }
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                {/* <div className="d-flex">
              <label>หมายเหตุ : </label>
              <input
                type="text"
                className="form-control input-spacing"
                name="whDocRemark"
                value={formMasterList.whDocRemark || ''}
                onChange={handleChangeMaster}
                disabled={isDisabled} />
            </div> */}
                {/* <div className="d-flex">
              <label>จากคลัง : </label>
              <select
                class="form-select"
                value={selectedWarehouseFrom}
                onChange={(e) => handleChangeWarehouse(e.target.value, 'FROM')}>
                <option value={null}>
                  กรุณาระบุคลัง
                </option>
                {whFromDataList.map((warehouse) => (
                  <option
                    key={warehouse.WH_Id}
                    value={warehouse.WH_Id}
                  >
                    {warehouse.WH_Name}
                  </option>
                ))}
              </select>
            </div> */}
              </div>
              <div className="col-4">
                <div className="d-flex align-items-center">
                  <label>เลขที่ภาษี</label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={formMasterList.arTaxNo || ""}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                {/* <div className="d-flex">
              <label>ไปคลัง :</label>
              <select
                class="form-select"
                value={selectedWarehouseTo}
                onChange={(e) => handleChangeWarehouse(e.target.value, 'TO')}>
                <option value={null}>
                  กรุณาระบุคลัง
                </option>
                {whToDataList.map((warehouse) => (
                  <option
                    key={warehouse.WH_Id}
                    value={warehouse.WH_Id}
                  >
                    {warehouse.WH_Code} ({warehouse.WH_Name})
                  </option>
                ))}
              </select>
            </div> */}
              </div>
              <div className="col-4">
                {/* <div className="d-flex">
              <label>หมายเหตุ : </label>
              <input
                type="text"
                className="form-control input-spacing"
                name="whDocRemark"
                value={formMasterList.whDocRemark || ''}
                onChange={handleChangeMaster}
                disabled={false} />
            </div> */}
              </div>
            </div>
          </div>
          <hr />
        </div>
        <div className="container-fluid my-3">
          <div className="row">
            <div className="col-12">
              <div className="col-12">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="card-title">รายละเอียดสินค้า</h4>
                    <button
                      className="btn text-white mx-3"
                      onClick={handleSoShow}
                      style={{
                        backgroundColor: "rgb(239, 108, 0)",
                        whiteSpace: "nowrap",
                        padding: "10px",
                        fontSize: "15px",
                      }}
                      disabled={
                        formMasterList.arID === null ||
                          formMasterList.docIsInv === 1 ||
                          formMasterList.docStatus === 13 ||
                          (mode === "U" && formMasterList.docPaidStatus !== 0)
                          ? true
                          : false
                      }
                    >
                      <i className="fa fa-plus"></i> เพิ่มรายการ
                    </button>
                    <BilSoModal
                      showSoModal={showSoModal}
                      handleSoClose={handleSoClose}
                      soDataList={soDataList}
                      bilDatalist={bilDatalist}
                      onConfirmSoSelection={onConfirmSoSelection}
                      arId={formMasterList.arID}
                    />
                  </div>
                  <div className="card-body">
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "500px", overflowY: "auto" }}
                    >
                      <table
                        id="basic-datatables"
                        className="table table-striped table-hover"
                      >
                        <thead className="thead-dark">
                          <tr>
                            <th className="text-center" style={{ width: "3%" }}>
                              #
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "10%" }}
                            >
                              เลขที่ใบขาย
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "10%" }}
                            >
                              วันที่เอกสาร
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "45%" }}
                            >
                              ชื่อลูกค้า
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "10%" }}
                            >
                              รวมราคา
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "10%" }}
                            >
                              VAT
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "10%" }}
                            >
                              รวมสุทธิ
                            </th>

                          </tr>
                        </thead>
                        <tbody>
                          {formDetailList.length > 0 ? (
                            [...formDetailList]
                              .sort((a, b) => {
                                // เปรียบเทียบวันที่เอกสาร
                                const dateA = new Date(a.soDocDate);
                                const dateB = new Date(b.soDocDate);

                                if (dateA - dateB !== 0) {
                                  return dateA - dateB; // เรียงตามวันที่เอกสาร ASC
                                }

                                // ถ้าวันที่เท่ากัน เรียงตามเลขที่ใบขาย
                                return a.soNo.localeCompare(b.soNo, undefined, {
                                  numeric: true,
                                });
                              })
                              .map((item, index) => (
                                <tr key={item.itemId || index + 1}>
                                  {/* # */}
                                  <td className="text-center">{index + 1}</td>

                                  {/* เลขที่ใบขาย */}
                                  <td className="text-center">
                                    <span>{item.soNo || ""}</span>
                                  </td>

                                  {/* วันที่เอกสาร */}
                                  <td className="text-center">
                                    <span>
                                      {formatDateToStringDate(item.soDocDate) ||
                                        ""}
                                    </span>
                                  </td>

                                  {/* ชื่อลูกค้า */}
                                  <td className="text-left">
                                    <span>{item.arName || ""}</span>
                                  </td>

                                  {/* รวมราคา */}
                                  <td className="text-end">
                                    <span>
                                      {mode === "U"
                                        ? formatCurrency(item.itemTotal) || 0.0 || formatCurrency(item.BL_Total)
                                        : item.itemTotal || 0.0 || item.BL_Total}
                                    </span>
                                  </td>

                                  {/* VAT */}
                                  <td className="text-end">
                                    <span>
                                      {mode === "U"
                                        ? formatCurrency(item.totalVat) || 0.0 || formatCurrency(item.BL_Vat)
                                        : item.totalVat || 0.0 || item.BL_Vat}
                                    </span>
                                  </td>

                                  {/* รวมสุทธิ */}
                                  <td className="text-end">
                                    <span>
                                      {mode === "U"
                                        ? formatCurrency(item.netTotal) || 0.0 || formatCurrency(item.BL_Net_Total)
                                        : item.netTotal || 0.0 || item.BL_Net_Total}
                                    </span>
                                  </td>

                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td colSpan="8">
                                <center>
                                  <h5>ไม่พบรายการสินค้า</h5>
                                </center>
                              </td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td
                              colSpan="4"
                              className="text-end"
                              style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "#333",
                              }}
                            >
                              <div className="text-end">
                                <span>รวมราคา</span>
                              </div>
                            </td>
                            <td
                              colSpan="1"
                              className="text-end"
                              style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "#333",
                              }}
                            >
                              {/* รวมราคา */}
                              <span
                                className="text-end"
                                style={{ color: "#EF6C00" }}
                              >
                                {formatCurrency(soTotal)}
                              </span>
                            </td>
                            <td
                              colSpan="1"
                              className="text-end"
                              style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "#333",
                              }}
                            >
                              {/* VAT */}
                              <span style={{ color: "#EF6C00" }}>
                                {formatCurrency(soTotalVat)}
                              </span>
                            </td>
                            <td
                              colSpan="1"
                              className="text-end"
                              style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "#333",
                              }}
                            >
                              {/* รวมราคาสุทธิ */}
                              <span style={{ color: "#EF6C00" }}>
                                {formatCurrency(soNetTotal)}
                              </span>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4">
                        {/* <h4 className="card-title">ส่วนลดท้ายบิล</h4> */}
                        <div className="row mt-3">
                          {/* <div className="col-3">
                            <div className="d-flex align-items-center">
                              <label className="mr-2 flex-grow-1">ส่วนลดมูลค่า</label>
                            </div>
                          </div>
                          <div className="col-3">
                            <input
                              type="text"
                              className="form-control text-end"
                              name="discountValue"
                              value={formMasterList.discountValue}
                              onChange={handleChangeMaster}
                              onInput={(e) => {
                                if (/^0+/.test(e.target.value)) {
                                  e.target.value = e.target.value.replace(/^0+/, '');

                                  // หากกรอกเฉพาะจุดทศนิยม ให้เติม 0 ด้านหน้า (เช่น .5 -> 0.5)
                                  if (e.target.value.startsWith(".")) {
                                    e.target.value = "0" + e.target.value;
                                  }
                                }
                              }}
                            />
                          </div>
                          <div className="col-3">
                            <div className="row">
                              <div className="radio-inline">

                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="2"
                                  checked={selectedDiscountValueType === '2'}
                                  onChange={handleCheckboxChange}
                                  disabled={true}
                                />
                                <label className="form-check-label">%</label>
                              </div>
                            </div>
                          </div>
                          <div className="col-3">
                            <input
                              type="text"
                              className="form-control text-end"
                              name="discountValueTotal"
                              value={receiptDiscount || ''}
                              onChange={handleChangeMaster}
                              disabled={true}
                            />
                          </div> */}
                        </div>
                      </div>
                      <div className="col-4"></div>
                      <div className="col-4">
                        <h4 className="card-title">ยอดท้ายบิล</h4>
                        <div className="row mt-3">
                          <div className="col-12">
                            <div className="d-flex justify-content-end align-items-center mt-1">
                              <label>รวมราคา</label>
                              <input
                                type="text"
                                className="form-control text-end input-spacing"
                                style={{ width: "100px" }}
                                value={formatCurrency(totalPrice || 0)}
                                disabled={true}
                              />
                            </div>
                            <div className="d-flex justify-content-end align-items-center mt-1">
                              <label className="mr-3">VAT (7%)</label>
                              <input
                                type="text"
                                className="form-control text-end input-spacing"
                                style={{ width: "100px" }}
                                value={formatCurrency(vatAmount || 0)}
                                disabled={true}
                              />
                            </div>
                            <hr />
                            {/* <div className="d-flex justify-content-end align-items-center mt-1">
                              <label>ราคารวมสุทธิ</label>
                              <input
                                type="text"
                                className="form-control text-end input-spacing"
                                style={{ width: '100px' }}
                                value={formatCurrency(totalPrice + vatAmount || 0)}
                                disabled={true}
                              />
                            </div> */}
                            {/* <div className="d-flex justify-content-end align-items-center mt-1">
                              <label>รวมส่วนลด</label>
                              <input
                                type="text"
                                className="form-control text-end input-spacing"
                                style={{ width: '100px' }}
                                value={formatCurrency(receiptDiscount || 0)}
                                disabled={true}
                              />
                            </div> */}
                            {/* <hr /> */}
                            <div className="d-flex justify-content-end align-items-center mt-1">
                              <label>
                                <h5>ราคารวมสุทธิ</h5>
                              </label>
                              <input
                                type="text"
                                className="form-control text-end input-spacing"
                                style={{
                                  width: "100px",
                                  color: "red",
                                  fontWeight: "bold",
                                  fontSize: "18px",
                                }}
                                value={formatCurrency(grandTotal || 0)}
                                disabled={true}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <PaymentModal
                mode={mode}
                show={showPayTypeModal}
                grandTotal={grandTotal}
                paymentType={paymentType}
                setPaymentType={setPaymentType}
                paymentAmount={paymentAmount}
                setPaymentAmount={setPaymentAmount}
                handlePayTypeClose={handlePayTypeClose}
                handleUpdatePayment={handleSubmitPayment}
                handleUploadSlip={handleUploadSlip}
                base64Image={base64Image}
                setBase64Image={setBase64Image}
                chequeNo={chequeNo}
                setChequeNo={setChequeNo}
                chequeName={chequeName}
                setChequeName={setChequeName}
                chequeBranch={chequeBranch}
                setChequeBranch={setChequeBranch}
                showConfirmModal={showConfirmModal}
                setShowConfirmModal={setShowConfirmModal}
                checkPayment={checkPayment}
              />
            </div>
          </div>
        </div>
      </div>
      <FormAction
        onSubmit={() =>
          parseCurrency(grandTotal) === 0
            ? getAlert("FAILED", "กรุณาเพิ่มรายการ หรือ ใส่จำนวนเงินก่อนบันทึก")
            : setShowPayTypeModal(true)
        }
        onUpdate={handleUpdate}
        onCancel={handleCancel}
        onApprovedPay={handlePayTypeShow}
        onSubmitTax={handleTax}
        onUpdatePaid={handleUpdatePaidStatus}
        docStatus={formMasterList.docPaidStatus}
        mode={mode}
        disabled={
          formMasterList.docStatus === 5 || formMasterList.docStatus === 13
            ? true
            : false
        }
        disabledInv={
          formMasterList.docStatus === 5 || formMasterList.docStatus === 13
            ? true
            : false
        }
        disabledPay={
          formMasterList.docStatus === 5 || formMasterList.docStatus === 13
            ? true
            : false
        }
        footer={true}
      />
    </>
  );
};

export default FormWater;
